var map = {
	"./gogo.dark.blue.scss": [
		4882,
		4882
	],
	"./gogo.dark.green.scss": [
		1901,
		1901
	],
	"./gogo.dark.orange.scss": [
		1404,
		9023
	],
	"./gogo.dark.purple.scss": [
		1444,
		1444
	],
	"./gogo.dark.red.scss": [
		649,
		649
	],
	"./gogo.light.blue.scss": [
		8642,
		8642
	],
	"./gogo.light.green.scss": [
		9597,
		9597
	],
	"./gogo.light.orange.scss": [
		9548,
		9548
	],
	"./gogo.light.purple.scss": [
		1428,
		1428
	],
	"./gogo.light.red.scss": [
		7737,
		7737
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4938;
module.exports = webpackAsyncContext;